import {useState, useRef, useCallback} from 'react'
import {useAsyncFn} from 'react-use'
import {verifyAbn} from '../../api'

const useAbnVerification = ({supplierId, authenticityToken}) => {
  const [status, setStatus] = useState('idle')
  const [entityName, setEntityName] = useState(null)
  const verifiedAbnRef = useRef(null)

  const [, doVerify] = useAsyncFn(
    async (abn) => {
      setStatus('loading')
      setEntityName(null)
      verifiedAbnRef.current = abn

      const result = await verifyAbn({supplierId, authenticityToken, abn})

      if (result.status === 'valid') {
        setEntityName(result.entityName ?? null)
        setStatus('valid')
      } else {
        setStatus('invalid')
      }
    },
    [supplierId, authenticityToken],
  )

  const triggerVerification = useCallback(
    (abn) => {
      doVerify(abn)
    },
    [doVerify],
  )

  const resetVerification = useCallback(() => {
    setStatus('idle')
    setEntityName(null)
    verifiedAbnRef.current = null
  }, [])

  return {status, entityName, verifiedAbnRef, triggerVerification, resetVerification}
}

export default useAbnVerification
